import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsClustersRedesign } from 'shared/map-search/selectors/clustersType';

import { InfrastructureControlContainer, InfrastructureDropdownContainer } from './Infrastructure';
import { ListingButtonContainer } from './ListingButton';
import { ProfessionalSearchButtonContainer } from './ProfessionalSearchButton';
import { Navigation, NavigationButtons } from '../../components/Navigation';

export const NavigationDesktopContainer: React.FC = () => {
  const isClustersRedesign = useSelector(selectIsClustersRedesign);
  const infrastructureControlRef = React.useRef<HTMLButtonElement>(null);

  return (
    <Navigation indent="L">
      <NavigationButtons indent="L">
        <InfrastructureControlContainer ref={infrastructureControlRef} />
        <ProfessionalSearchButtonContainer />
        {isClustersRedesign ? null : <ListingButtonContainer />}
      </NavigationButtons>
      <InfrastructureDropdownContainer controlRef={infrastructureControlRef} />
    </Navigation>
  );
};

NavigationDesktopContainer.displayName = 'NavigationDesktopContainer';
